import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {DiagnosisDTO} from '../models/DiagnosisDTO';

@Injectable({
  providedIn: 'root'
})
export class DiagnosisService {
  private url = environment.baseUrl + '/diagnosis';

  constructor(private httpClient: HttpClient) {
  }

  getListOfDiagnoses(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<DiagnosisDTO>> {
    return this.httpClient.post<PagedResponseDTO<DiagnosisDTO>>(this.url + '/filter', pagedRequestDTO);
  }
}
